export default __webpack_public_path__ + "static/media/cloud-2-night.6fdde14b.svg";